import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PracticeAreasPage = lazy(() => import('../pages/practice-areas/page'));
const AttorneyProfilePage = lazy(() => import('../pages/attorney-profile/page'));
const NewsCoveragePage = lazy(() => import('../pages/news-coverage/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/practice-areas',
    element: <PracticeAreasPage />,
  },
  {
    path: '/practice-areas/civil-rights',
    element: <PracticeAreasPage />,
  },
  {
    path: '/practice-areas/police-misconduct',
    element: <PracticeAreasPage />,
  },
  {
    path: '/practice-areas/criminal-defense',
    element: <PracticeAreasPage />,
  },
  {
    path: '/attorney-profile',
    element: <AttorneyProfilePage />,
  },
  {
    path: '/news-coverage',
    element: <NewsCoveragePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;